import {Dropdown, DropdownItem, IconButton} from 'platform/components';

import {prop} from 'ramda';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {DASHBOARD_TILE_CATALOGUE} from '../../consts/dashboardTileCatalogue';
import {DASHBOARD_TILE_SIZE_LABELS} from '../../consts/dashboardTileSizeLabels';
import {DashboardTileId} from '../../types/DashboardTileId';
import {DashboardTileSize} from '../../types/DashboardTileSize';
import {DashboardTileSizeShape} from './DashboardTileSizeShape';

interface DashboardTileSizeChooserProps extends TestIdProps {
  tileId: DashboardTileId;
  size: DashboardTileSize;
  onResize: (id: DashboardTileId, size: DashboardTileSize) => void;
}

export function DashboardTileSizeChooser(props: DashboardTileSizeChooserProps) {
  const sizes = prop(props.tileId, DASHBOARD_TILE_CATALOGUE).sizes;

  return (
    <Dropdown
      placement="bottom-end"
      dropdownControl={
        <IconButton
          icon="action/aspect_ratio"
          size="default"
          iconSize="large"
          aria-label={i18n.t('page.homepage.dashboardLayout.resizeTile')}
        />
      }
      data-testid={suffixTestId('tileSize', props)}
    >
      {sizes.map((size) => (
        <DropdownItem
          key={size}
          label={i18n.t(prop(size, DASHBOARD_TILE_SIZE_LABELS))}
          prefix={<DashboardTileSizeShape size={size} />}
          isActive={size === props.size}
          onClick={() => props.onResize(props.tileId, size)}
          data-testid={suffixTestId(`tileSize-${size}`, props)}
        />
      ))}
    </Dropdown>
  );
}
